export default __webpack_public_path__ + "static/media/preview.3859bd92.png";